import type {
  PriceRangeReportQueryDto,
  PriceRangeReportResponseDto,
} from "../../types/priceRangeReport";
import {baseApi} from "./baseApi";

export const priceRangeReportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get Price Range Report
    getPriceRangeReport: builder.query<
      PriceRangeReportResponseDto,
      PriceRangeReportQueryDto
    >({
      query: (params) => ({
        url: "/dashboard/price-range-report",
        params: {
          // Only include defined parameters
          ...(params.sortBy && {sortBy: params.sortBy}),
          ...(params.sortOrder && {sortOrder: params.sortOrder}),
          ...(params.period && {period: params.period}),
          ...(params.regionId && {regionId: params.regionId}),
          ...(params.propertyTypeId && {propertyTypeId: params.propertyTypeId}),
          ...(params.listingType && {listingType: params.listingType}),
        },
      }),
      providesTags: ["Dashboard"],
      // Transform response if needed
      transformResponse: (response: PriceRangeReportResponseDto) => response,
    }),
  }),
  overrideExisting: false,
});

export const {useGetPriceRangeReportQuery} = priceRangeReportApi;
